<div class="body">
  <div class="float-right close-x" (click)="close()"><span class="icon">&#x00D7;</span></div>
  <h1>{{ editMode ? 'View': 'Create a' }} Recurring Promotion <fa-icon class="fa-rotate" size="lg" [icon]="faArrowsRotate"></fa-icon></h1>
  <p class="headline">You can setup a recurring promotion based on this promotion. This is a great way to set it and forget it.</p>
  @if (feature) {
    <div class="promotion">
      <div class="flex align-items-center">
        <div class="cover">
          <img src="{{ feature._book.amazonImageUrl }}" alt="{{ feature._book.title }}" />
        </div>
        <div class="book-details flex flex-direction-column gap-4 flex-grow-1">
          <div class="title">{{ feature._book.title }}</div>
          <div class="site">{{ site?.name }}</div>
          <div class="site-advert">{{ siteAdvert?.name }}</div>
          <div class="book-price">Book price {{ feature.bookPriceDuringPromo | currency:'USD':true:'1.2-2' }}</div>
        </div>
        <img class="site-logo" [src]="siteImage" />
        <fa-icon class="fa-rotate" [icon]="faArrowsRotate"></fa-icon>
        <div class="promotion-price">{{ siteAdvert.price | currency:'USD':true:'1.2-2' }}</div>
      </div>
    </div>
  }
  <div class="recurrence-container">
    <h4>Recurrence</h4>
    <p>How often do you want to run this promotion?</p>
    <div class="recurrence-options">
      <button
        (click)="setRecurrence(45)"
        [class]="{selected: recurrence === 45}"
        class="btn xsm-square invert"
        [disabled]="editMode"
        >
        45 days
      </button>
      <button
        (click)="setRecurrence(60)"
        [class]="{selected: recurrence === 60}"
        class="btn xsm-square invert"
        [disabled]="editMode"
        >
        60 days
      </button>
      <button
        (click)="setRecurrence(90)"
        [class]="{selected: recurrence === 90}"
        class="btn xsm-square invert"
        [disabled]="editMode"
        >
        90 days
      </button>
    </div>

    @if (editMode) {
      <div>
        <label>Start date:</label>
        {{startDate | date: 'MM/dd/yyyy'}}
      </div>
    } @else {
      <app-datepicker
        label="Start date:"
        id="recurring-start-date"
        [startDate]="startDate"
        (dateChange)="handleDateChange($event)"
      ></app-datepicker>
    }

    @if (isSchedulingConflict && !editMode) {
      <div class="alert">
        <p>
          Unfortunately we are out of inventory for one or more of the dates selected for this promotion to recur on.
          Please select a different date. If you continue to have issues please contact support.
        </p>
        <button class="btn">Contact Support</button>
      </div>
    }

    @if (recurrence && !isSchedulingConflict) {
      <div class="next-3 italic">
        Next 3 promo dates
        <ul>
          @for (promo of upcomingPromotions; track promo) {
            <li>
              @if (promo.pending) {
                <div>
                  <span class="recurring-date">{{ promo.date | date: 'MMM d, y' }}</span>
                  - will be billed as soon as inventory is available
                </div>
              } @else {
                <span class="recurring-date">{{ promo.date | date: 'MMM d, y' }}</span>
                - will be billed immediately since this date is already available
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div>
    <h4>Credit Card on File</h4>
    <p>In order to setup a recurring promotion you will need to have a credit card on file with Written Word Media.</p>
    <div [hidden]="stripePrimaryPaymentMethod && !showCardForm">
      @if ((stripePaymentMethods.length || stripePrimaryPaymentMethod)) {
        <a (click)="showCardForm = false" class="show-saved-cards">
          Use a saved card
        </a>
      }
      <div id="stripe-card"></div>
      @if (user) {
        <div>
          <input type="checkbox" id="save-card" [(ngModel)]="optedInToSaveCard">
          <label for="save-card">
            Save this credit card on my account to make checkout easier next time
          </label>
        </div>
      }

    </div>
    @if ((!showCardForm && user) && (stripePaymentMethods.length || stripePrimaryPaymentMethod)) {
      <app-stripe-stored-cards
        [user]="user"
        [customer]="stripeCustomer"
        [paymentMethods]="stripePaymentMethods"
        [primaryPaymentMethod]="stripePrimaryPaymentMethod"
        (selectedCard)="selectedStripeCard($event)"
        (useNewCard)="showCardForm = true"
        [hideNewCardOption]="true"
        (cardHint)="setCardHint($event)"
      ></app-stripe-stored-cards>
    }
  </div>
  <form [formGroup]="confirmationsForm" (onSubmit)="schedule()">
    <div class="flex gap-8">
      <input type="checkbox" id="confirmation" name="confirmation" value="confirmation" formControlName="charge">
      <p>
        I understand that my credit card ending in {{ cardHint }} will be charged as
        soon as the appropriate dates become available. Which may be as soon as today, {{ today | date: 'MMM d, y' }}.
      </p>
    </div>
    @if (!isSchedulingConflict && !editMode) {
      <button type="submit" class="btn btn-primary" [disabled]="processing" (click)="schedule()">{{ processing ? 'Processing...' : 'Save' }}</button>
    }
    <a class="underline bold" (click)="close()">Cancel</a>
  </form>
</div>
<app-new-error-modal modalId="recurring-feature-error" [options]="modalErrorOptions"></app-new-error-modal>
<app-success-modal modalId="recurring-feature-success" text="Succesfully scheduled recurring features!"></app-success-modal>
